import * as React from 'react';
import { Routes, Route, Navigate, useLocation, NavLink, useNavigate, matchRoutes, MemoryRouter } from "react-router-dom";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { Accordion, AccordionDetails, AccordionSummary, Breadcrumbs, Button, createTheme, Icon, Link, Menu, MenuItem, Tab, Tabs, useMediaQuery } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import { createContext, JSX, useContext, useMemo, useState } from 'react';
import { light } from '@mui/material/styles/createPalette';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import routes, { T_route } from "./routes";
import { AccountCircle } from '@mui/icons-material';
import SignIn from './pages/sign/SignIn';
import { initialAppState, useAppState } from './contexts/appState';
import apis, { initApis, initApis2 } from './common/apis';
import InqueryList from './pages/inquery';

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: 0,
  [theme.breakpoints.up('sm')]: {
    width: 0,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% )`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    variants: [
      {
        props: ({ open }) => open,
        style: {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
        },
      },
      {
        props: ({ open }) => !open,
        style: {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        },
      },
    ],
  }),
);




export default function APP() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [auth,setAuth] = useState();
  const {appState,setAppState} = useAppState();
  const user = appState.user;

  const navigate = useNavigate();
  const location = useLocation();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  const handleDrawer = () => {
    open ? setOpen(false) :setOpen(true)
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);  // anchorEl이 null이 아니면 true

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  

  const handleLogout = async() => {
    const result =  await apis.user.logout();
    console.log(result)
    await setAppState({});


  };

  React.useEffect(()=>{
    setAnchorEl(null);
  
    if(appState.user != null){
        console.log("appInit:",appState)
      initApis2(appState);
    }
  },[appState])


  const getRoutes = (allRoutes: any) => {
    const children: JSX.Element[] = [];
    allRoutes.map((route: any) => {
      if (route.routes) {
        const newChildren = getRoutes(route.routes);
        for (let idx = 0; idx < newChildren.length; idx++) {
          const newChildrenItem = newChildren[idx];
          children.push(newChildrenItem);
        }
      }
      if (route.route) {
        children.push(<Route path={route.route} element={route.component} key={route.key}  />);
      }
    });

    return children;
  };


    // 사용자 역할에 따른 메뉴 렌더링
 const renderRoutes = (routes:T_route[]) => {

      return routes
        .map(({ type, name, icon, title, noCollapse, auth, key, href, route ,routes},index) => {
          let returnValue = null;
  
          if (type === "collapse") {
            const isActive =
            location.pathname === route ||
            location.pathname.startsWith(route + '/');

           returnValue =  (
                <ListItem key={index} disablePadding sx={{ display: 'block' }} >
                 <ListItemButton
                     selected={isActive}           
                  sx={[{ minHeight: 48, px: 2.5,},
                    open ? { justifyContent: 'initial',}: { justifyContent: 'center', },
                  ]}
                  onClick={()=>{
                    navigate(key);
                  }}
                >
                  <ListItemIcon
                    sx={[
                      {
                        minWidth: 0,
                        justifyContent: 'center',
                      },
                      open
                        ? {
                            mr: 3,
                          }
                        : {
                            mr: 'auto',
                          },
                    ]}
                  >
                    {icon && icon}
                    <Icon baseClassName="fas" className="fa-plus-circle" />
                  </ListItemIcon>
                  <ListItemText
                   primary={name}
                    sx={[open? { opacity: 1,}: { opacity: 0,},
                    ]}
                    
                  />
                </ListItemButton>
              </ListItem>
           )
          }  else if (type === "title") {
            returnValue = (
              <Accordion disableGutters       // 패딩(여백) 제거
              elevation={0}        // 그림자 제거
              square               // 둥근 모서리 비활성화
              sx={{
                border: 'none',    // 혹시 남아있는 경계선 제거
                boxShadow: 'none', // 추가 안전장치로 box-shadow도 없음
              }}

              key={index}
          >
                 <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{margin:0,paddingLeft:1,paddingRight:5,height:40}}
                  >
                
                 <ListItem  > 
                 <ListItemIcon
                  >
                    <InboxIcon /> 
                  </ListItemIcon>
                  <ListItemText
                   primary={name}
                    sx={[open? { opacity: 1,}: { opacity: 0,},
                    ]}
                    
                  />
                    </ListItem>
                  </AccordionSummary>
                  <AccordionDetails sx={{}}>
                    {routes && renderRoutes(routes)}
                  </AccordionDetails>
                </Accordion>
            );
          } else if (type === "divider") {
            returnValue = (
              <Divider
                key={index}
              />
            );
          }
    
          return returnValue;
        })
        .filter((route) => route !== null); // null 값 필터링
    };
  
    if (!user) {
      return (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SignIn />
        </ThemeProvider>
      );
    }
  

  // 1) 토글 기능을 Context로 분리
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <Box sx={{ display: 'flex' }}>
          <AppBar position="fixed" open={open}>
            <Toolbar>
              <IconButton color="inherit" onClick={handleDrawer} edge="start" sx={{ mr: 5 }}>
                {open ? <ChevronLeftIcon /> : <MenuIcon />}
              </IconButton>
              <Typography variant="h6" noWrap component="div">
                SLNC A/S 관리
              </Typography>
              <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                <IconButton size="large" onClick={handleMenu} color="inherit">
                  <AccountCircle />
                </IconButton>
                {anchorEl && (
                <Menu
                  anchorEl={anchorEl}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  keepMounted={false}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  open={menuOpen}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleClose}>Profile</MenuItem>
                  <MenuItem onClick={handleClose}>My account</MenuItem>
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
                )}
              </Box>
            </Toolbar>
          </AppBar>
          <Drawer variant="permanent" open={open}>
            <DrawerHeader>
              <IconButton onClick={handleDrawer}>
                {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
              </IconButton>
            </DrawerHeader>
            <List>{renderRoutes(routes)}</List>
          </Drawer>
          <Box component="main" sx={{ p: 3,width:'100%' }}>
            <DrawerHeader />
            <Routes>
            <Route path="/" element={<Navigate to={routes[0].route} replace />} />
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Box>
        </Box>
    </ThemeProvider>
  );

}